import { withStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import TabsConstants from "../../../constants";
import ContractFields from "./ContractFields";
import TicketFields from "./TicketFields";


const styles = theme => ({
  root: {
    marginTop: 20
  },
  farmInfomationTabs: {
    border: "solid 1px #eee",
    marginTop: 10,
    padding: 0
  },
  bigIndicator: {
    height: 2,
    backgroundColor: "#00bc84"
  },
  activeTab: {
    color: "#00bc84 !important",
    fontWeight: "bold"
  },
  Tabs: {
    fontWeight: "bold"
  }
});

const CHILD_ROUTES = {
  TICKET: "ticket",
  CONTRACT: "contract"
};

class MandatoryFields extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: CHILD_ROUTES.TICKET,
      tabs: TabsConstants.MandatoryFieldsScreen
    };
  }

  componentWillMount() {
    const path = window.location.pathname;
    if (
      path.includes(CHILD_ROUTES.TICKET) ||
      path === "/settings/mandatory-fields"
    ) {
      this.setState({ value: CHILD_ROUTES.TICKET });
    } else if (path.includes(CHILD_ROUTES.CONTRACT)) {
      this.setState({ value: CHILD_ROUTES.CONTRACT });
    }
  }

  onTabChange = (e, value) => {
    this.setState({
      value: value
    });
  };

  render() {
    const { classes } = this.props;
    const { value, tabs } = this.state;
    return (
      <div className={classes.root}>
        <Tabs
          className={classes.farmInfomationTabs}
          onChange={this.onTabChange}
          value={value}
          variant="scrollable"
          scrollButtons="off"
          classes={{ indicator: classes.bigIndicator }}
        >
          {tabs.map((tab, index) => (
            <Tab
              component={Link}
              to={tab.link}
              key={index}
              value={tab.value}
              label={tab.TabName}
              aria-label={tab.TabName}
              className={value === tab.value ? classes.activeTab : classes.Tabs}
            />
          ))}
        </Tabs>
        {value === CHILD_ROUTES.TICKET && <TicketFields />}
        {value === CHILD_ROUTES.CONTRACT && <ContractFields />}
      </div>
    );
  }
}

export default connect(null)(withStyles(styles)(MandatoryFields));



// WEBPACK FOOTER //
// ./src/components/private/MandatoryFields/MandatoryFields.js